import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type { TcrBrand, TcrCampaign, TcrListParams, TcrPhoneNumber } from './adminTenDlcClient.types';

class AdminTenDlcClient extends BaseClient {
    getTcrBrands(params?: TcrListParams): AxiosPromise<CursorPaginationResponse<TcrBrand>> {
        const url = '/api/admin/tcr-brands';
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getTcrCampaigns(params?: TcrListParams): AxiosPromise<CursorPaginationResponse<TcrCampaign>> {
        const url = '/api/admin/tcr-campaigns';
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    getTcrPhoneNumbers(params?: TcrListParams): AxiosPromise<CursorPaginationResponse<TcrPhoneNumber>> {
        const url = '/api/admin/tcr-phone-numbers';
        return this.makeCoreApiRequest(url, 'get', null, params);
    }
}

export default new AdminTenDlcClient();
